// Side-agnostic equivalent of `views/suppliersBalance/enums/suppliersBalanceSortProperty.ts`;
// feature-owned since no generic version exists yet.
export enum BalanceSortProperty {
  AccountNumber = 'auxiliaryAccountNo',
  Name = 'contactName',
  Balance = 'balance',
  LastPeriod = 'comparisonBalance',
  Variance = 'variance',
  VariancePercentage = 'variancePercent',
}
